import { render, staticRenderFns } from "./nice-range-viz.vue?vue&type=template&id=5124d1cd&scoped=true"
import script from "./nice-range-viz.vue?vue&type=script&lang=js"
export * from "./nice-range-viz.vue?vue&type=script&lang=js"
import style0 from "./nice-range-viz.vue?vue&type=style&index=0&id=5124d1cd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124d1cd",
  null
  
)

export default component.exports